import React, {useEffect, useState} from 'react'
import { AppContent, AppSidebar, AppFooter, AppHeader } from './index'
import { webSocketService } from '../../../websocket/WebSocketService';
import {connect, useDispatch, useSelector} from "react-redux";
import {useNavigate, useLocation} from "react-router-dom";
import Navigation from "../../../_nav";
import { getHeader, getSiteSetting } from '../../../api/api';
import { configActions } from '../../../redux/actions/config';

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

import {ClientSideRowModelModule, ModuleRegistry} from "ag-grid-community";
import {AllEnterpriseModule, provideGlobalGridOptions, RowGroupingModule} from "ag-grid-enterprise"
ModuleRegistry.registerModules([
    ClientSideRowModelModule,
    AllEnterpriseModule,
    RowGroupingModule
]);
provideGlobalGridOptions({ theme: "legacy"});

const DefaultLayout = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const {user} = useSelector((props) => props.account);
    const [counts, setCounts] = useState({
        depositCount: 0,
        withdrawCount: 0,
        userRegisterCount: 0,
        inquiryCount: 0,
        highBettingCount: 0
    });

    const menu = Navigation();
    const [loading, setLoading] = useState(false);
    const [userMenuList, setUserMenuList] = useState([]);
    const [selectedMenu, setSelectedMenu] = useState(menu[0]);
    const [refreshKey, setRefreshKey] = useState(0);
    const [soundIntervals, setSoundIntervals] = useState({});

    useEffect(() => {
        if (user === undefined || user === null) {
            navigate("/login");
        }
    }, [])

    // location.state.key가 변경될 때마다 컴포넌트를 리렌더링
    useEffect(() => {
        if (location.state?.key !== undefined) {
            setRefreshKey(location.state.key);
        }
    }, [location.state?.key]);

    useEffect(() => {
        if (user === undefined) {
            navigate("/login");
            return;
        }

        if (user && user.companyCode) {
            fetchHeaderCounts();
            
            // 2초마다 fetchHeaderCounts 실행
            const interval = setInterval(() => {
                fetchHeaderCounts();
            }, 2000);
            
            // 컴포넌트 언마운트 시 interval 정리
            return () => {
                clearInterval(interval);
            };
        }

        // 웹소켓 연결
        webSocketService.connect();
        // admin topic 구독
        webSocketService.subscribe('admin', handleAdminMessage);

        // 컴포넌트 언마운트 시 웹소켓 연결 해제 및 구독 해제
        return () => {
            webSocketService.unsubscribe('admin', handleAdminMessage);
            webSocketService.disconnect();
        };
    }, [user]);

    // 메인 진입 시 siteConfig 조회 후 Redux에 보관
    useEffect(() => {
        if (!user?.companyCode) return;
        getSiteSetting({ companyCode: user.companyCode })
            .then((result) => {
                const { data, status } = result;
                if (status === 200 && data?.siteConfig) {
                    dispatch(configActions.setSiteConfig(data.siteConfig));
                }
            })
            .catch(() => {});
    }, [user?.companyCode, dispatch]);

    // 헤더 카운트 정보를 가져오는 함수
    const fetchHeaderCounts = async () => {
        try {
            const response = await getHeader({ companyCode: user.companyCode });
            if (response && response.data && response.data.success) {
                const headerData = response.data.data;

                // 이전 카운트와 비교하여 변경이 있을 때만 사운드 재생
                setCounts(prevCounts => {
                    const newCounts = {
                        depositCount: headerData.depositCount || 0,
                        withdrawCount: headerData.withdrawCount || 0,
                        userRegisterCount: headerData.userRegisterCount || 0,
                        inquiryCount: headerData.inquiryCount || 0,
                        highBettingCount: headerData.highBettingCount || 0
                    };

                    // 카운트가 변경되었을 때만 사운드 처리
                    if (prevCounts.depositCount !== newCounts.depositCount) {
                        const message = {
                            type: "USER_CASH_DEPOSIT",
                            waitingCount: newCounts.depositCount
                        };
                        handleAdminMessage(message);
                    }

                    if (prevCounts.withdrawCount !== newCounts.withdrawCount) {
                        const message = {
                            type: "USER_CASH_WITHDRAW",
                            waitingCount: newCounts.withdrawCount
                        };
                        handleAdminMessage(message);
                    }

                    if (prevCounts.userRegisterCount !== newCounts.userRegisterCount) {
                        const message = {
                            type: "USER_REGISTER",
                            waitingCount: newCounts.userRegisterCount
                        };
                        handleAdminMessage(message);
                    }

                    if (prevCounts.inquiryCount !== newCounts.inquiryCount) {
                        const message = {
                            type: "INQUIRY",
                            waitingCount: newCounts.inquiryCount
                        };
                        handleAdminMessage(message);
                    }

                    if (prevCounts.highBettingCount !== newCounts.highBettingCount) {
                        const message = {
                            type: "HIGH_BETTING",
                            waitingCount: newCounts.highBettingCount
                        };
                        handleAdminMessage(message);
                    }

                    return newCounts;
                });
            }
        } catch (error) {
            console.error('헤더 카운트 정보 가져오기 실패:', error);
        }
    };

    const goMenu = (menu, status) => {
        if (menu.to === '/cash/in-request') {
            stopSoundLoop('USER_CASH_DEPOSIT')
        }
        else if (menu.to === '/cash/withdraw-request') {
            stopSoundLoop('USER_CASH_WITHDRAW')
        }
        else if (menu.to === '/user/accept') {
            stopSoundLoop('USER_REGISTER')
        }
        else if (menu.to === '/customer/inquiry') {
            stopSoundLoop('INQUIRY')
        }
        else if (menu.to === '/betting/list') {
            stopSoundLoop('HIGH_BETTING')
        }

        if (location.pathname === menu.to) {
            const key = crypto.randomUUID();
            navigate(menu.to, {
                state: { key: key }
            });
        } else {
            // 다른 페이지로 이동
            navigate(menu.to);
            setSelectedMenu(menu);
        }
    }

    // 웹소켓 메시지 핸들러
    const handleAdminMessage = (message) => {
        console.log("### message :: ", message)
        let audioFile = '';

        switch (message.type) {
            case 'USER_REGISTER':
                setCounts(prev => ({
                    ...prev,
                    userRegisterCount: message.waitingCount
                }));
                if (message.waitingCount > 0) {
                    audioFile = 'Regist.mp3';
                    startSoundLoop('USER_REGISTER', audioFile);
                } else {
                    stopSoundLoop('USER_REGISTER');
                }
                break;

            case 'USER_CASH_DEPOSIT':
                setCounts(prev => ({
                    ...prev,
                    depositCount: message.waitingCount
                }));
                if (message.waitingCount > 0) {
                    audioFile = 'Charge.mp3';
                    startSoundLoop('USER_CASH_DEPOSIT', audioFile);
                } else {
                    stopSoundLoop('USER_CASH_DEPOSIT');
                }
                break;

            case 'USER_CASH_WITHDRAW':
                setCounts(prev => ({
                    ...prev,
                    withdrawCount: message.waitingCount
                }));
                if (message.waitingCount > 0) {
                    audioFile = 'Exchange.mp3';
                    startSoundLoop('USER_CASH_WITHDRAW', audioFile);
                } else {
                    stopSoundLoop('USER_CASH_WITHDRAW');
                }
                break;

            case 'INQUIRY':
                setCounts(prev => ({
                    ...prev,
                    inquiryCount: message.waitingCount
                }));
                if (message.waitingCount > 0) {
                    audioFile = 'Customer.mp3';
                    startSoundLoop('INQUIRY', audioFile);
                } else {
                    stopSoundLoop('INQUIRY');
                }
                break;

            case 'HIGH_BETTING':
                setCounts(prev => ({
                    ...prev,
                    highBettingCount: message.waitingCount
                }));
                if (message.waitingCount > 0) {
                    audioFile = 'Betting.mp3';
                    startSoundLoop('HIGH_BETTING', audioFile);
                } else {
                    stopSoundLoop('HIGH_BETTING');
                }
                break;
            default:
                break;
        }
    };

    const startSoundLoop = (type, audioFile) => {
        // 이미 interval이 있으면 중복 생성 방지
        if (soundIntervals[type]) {
            console.log(`이미 ${type} 사운드가 재생 중입니다.`);
            return;
        }

        const playSound = () => {
            const audio = new Audio(process.env.PUBLIC_URL + `/assets/sounds/${audioFile}`);
            audio.play().catch(e => console.error('오디오 재생 실패:', e));
        };

        playSound(); // 즉시 1회 재생
        const intervalId = setInterval(playSound, 5000);

        setSoundIntervals(prev => ({
            ...prev,
            [type]: intervalId
        }));
        
        console.log(`${type} 사운드 루프 시작`);
    };

    const stopSoundLoop = (type) => {
        console.log(`### stop type :: ${type}`);
        setSoundIntervals(prev => {
            if (prev[type]) {
                clearInterval(prev[type]);
                const newIntervals = { ...prev };
                delete newIntervals[type];
                console.log(`${type} 사운드 루프 중지`);
                return newIntervals;
            }
            return prev;
        });
    };

    return (
        <>
            {user !== undefined &&
            <div className={"bg-zinc-900"}>
                <AppSidebar 
                    setSelectedMenu={setSelectedMenu} 
                    userMenuList={userMenuList}
                    refreshKey={refreshKey}
                    setRefreshKey={setRefreshKey}
                />
                <div className="wrapper d-flex flex-column min-vh-100">
                    <AppHeader 
                        move={goMenu} 
                        counts={counts}
                    />
                    <div className="body flex-grow-1 bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100">
                        <AppContent key={refreshKey} />
                    </div>
                </div>  
            </div>
            }
        </>
    )
}

const mapStateToProps = (state) => {
    const {account, store} = state;
    return {
        account, store
    }
}

export default connect(mapStateToProps, null)(DefaultLayout);
